<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Edit Query</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>

<div class="main-body text-grey" style="padding: 24px 24px 10px 24px;">
  <div>
    <form name="editQuery" [formGroup]="editQuery">
      <div formArrayName="whereClause">
        <div style="display:flex; flex-direction:column; align-items:center; justify-content:space-between; margin:5px 0 5px 0"
             *ngFor="let clause of editQuery.get('whereClause')['controls']; let i = index"
             formGroupName="{{i}}">
          <div style="display:flex; flex-direction:row; align-items:center; justify-content:space-between; width:100%">
            <select style="width:30%" class="form-select form-select-sm margin-right" (change)="changeChanged(clause.value.type)" formControlName="type">
              <option value="">Select Type</option>
              <option *ngFor="let field of getJobQueryFields()" value="{{field.value}}">{{field.name}}</option>
            </select>
            <input [name]="i" class="form-control form-control-sm margin-right" type="text" formControlName="entry" />
            <button class="btn btn-outline-danger btn-sm" (click)="removeQuery(i)"><i class="bi bi-x-lg"></i></button>
          </div>
          <div>
            <label class="text-danger" [for]="i" *ngIf="(clause.get('type').touched && !clause.get('type').valid) || (clause.get('entry').touched && !clause.get('entry').valid)">Please select the parameter and enter the comma seperated values</label>
          </div>
        </div>
      </div>
      <div>
        <button style="margin-top: 5px; margin-bottom:5px; width: 153px" type="button" class="btn btn-outline-success btn-sm" (click)="addNewWhereCondition()"><i class="bi bi-plus-lg"></i>Add Filters</button>
      </div>
      <div class="modal-footer" style="display: flex; justify-content: space-between; align-items: center;">
        <button type="button" class="btn btn-danger" (click)="resetFilters()">Reset & Apply</button>
        <div>
          <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="onSubmit()">
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
